
  import Vue, {PropType} from "vue";
  import PwaPrice from "@/components/common/PwaPrice.vue";
  import PwaIcon from "@/components/common/PwaIcon.vue";
  import PwaCountdownMessage from "@/components/common/PwaCountdownMessage.vue";
  import PwaInscriptionNoMoney from "@/components/modals/competitions/PwaInscriptionNoMoney.vue";
  import PwaAcceptCompetitionProposalModal from "@/components/modals/competitions/PwaAcceptCompetitionProposalModal.vue";
  import PwaUserLevel from "@/components/user/PwaUserLevel.vue";
  import PwaDifferentLevelModal from "@/components/modals/competitions/PwaDifferentLevelModal.vue";
  import {MODAL_IDS} from "@/utils/modal";
  import {UserActionTypes} from "@/store/modules/user/actions";
  import PwaCreateMatchSuccess from "@/components/modals/competitions/PwaCreateMatchSuccess.vue";
  import {ROUTES} from "@/router/routes";
  import {NotificationCenterActionTypes} from "@/store/modules/notificationCenter/actions";
  import { COMPETITION_PROPOSAL_STATUS_ID } from '@/utils/competition';
  import {showInterstitial} from "@/services/ads";

  const limitBlock = 4;

  export default Vue.extend({
    name: "pwa-competitions-proposals",
    components: {
      PwaIcon,
      PwaPrice,
      PwaAcceptCompetitionProposalModal,
      PwaCountdownMessage,
      PwaUserLevel,
      PwaDifferentLevelModal,
    },
    props: {
      competitionsProposals: {
        type: Array,
        required: true,
      },
      competitionFreeInscriptions: {
        type: Array as PropType<Array<any>>,
        default: [],
        required: false,
      },
      isCompetitionsProposalsReceived: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data() {
      return {
        competitionsProposalsList: [],
        competitionProposalSelected: null,
        competitionProposalStatusId: COMPETITION_PROPOSAL_STATUS_ID,
        hasPendingCompetitionProposals: false,
        hasMoreCompetitionProposals: false,
      }
    },
    mounted(): void {
      this.updateCompetitionsProposalsList(this.competitionsProposals, true);
    },
    computed: {
      userGames(): Array<any> {
        return this.$store.state.user.games;
      },
    },
    methods: {
      onCompetitionProposalResponse(competitionProposal: Record<string, any>, accepted: number) {
        if (accepted) {
          if (competitionProposal.competition_free_inscription_id === undefined) {
            const awardId = competitionProposal.award_id;
            const costInscription = competitionProposal.cost_inscription;
            const competitionFreeInscription = this.competitionFreeInscriptions.find(({award_id, cost_inscription}) => (award_id === awardId || (!award_id && cost_inscription === costInscription)));
            competitionProposal.competition_free_inscription_id = competitionFreeInscription ? competitionFreeInscription.id : 0;
          }
          if (this.walletQuantity < competitionProposal.cost_inscription && !competitionProposal.competition_free_inscription_id) {
            this.showPopupNoMoney(competitionProposal);
          } else if (competitionProposal.game_needs_validation && !this.hasGameConfigured(competitionProposal.related_game_id)) {
            this.showPopupAddGame(competitionProposal.related_game_id);
          } else {
            const userLevel = competitionProposal?.opponent?.level || 0;
            const opponentLevel = competitionProposal?.owner?.level || 0;
            if (!competitionProposal.rematch_competition_id && userLevel > 0 && userLevel < opponentLevel) {
              this.showAcceptCompetitionDifferentLevelModal(competitionProposal);
            } else {
              this.showAcceptCompetitionProposalModal(competitionProposal);
            }
          }
        } else {
          this.showRejectCompetitionProposalModal(competitionProposal);
        }
      },
      async postCompetitionProposalResponse(competitionProposal: Record<string, any>, accepted: number, competitions_free_inscriptions_id = 0) {
        try {
          if (accepted && !competitions_free_inscriptions_id && this.walletQuantity < competitionProposal.cost_inscription) {
            this.showPopupNoMoney(competitionProposal);
          }else{
            this.showLoader(true);
            const {data} = await this.$http.competition.postCompetitionProposalResponse(competitionProposal.id, {accepted, competitions_free_inscriptions_id});
            this.$store.dispatch(UserActionTypes.UPDATE_USER_WALLET);
            this.$store.dispatch(NotificationCenterActionTypes.UPDATE_NOTIFICATION_CENTER);
            this.onSeeMoreClick(true);
            if (accepted) {
              competitionProposal.competition_id = data.data.competition_id;
              this.showMatchSuccessModal(competitionProposal, competitions_free_inscriptions_id);
            }
          }
        } catch ({response}) {
          const errorData = response?.data || {};
          const errorMessage = errorData?.message || errorData?.errors || this.$t('140');
          this.showLoader(false);
          this.showToastError(this.$t('139'), errorMessage);
        }
      },
      async postCompetitionProposalCancel(competitionProposal: Record<string, any>) {
        try {
          this.showLoader(true);
          await this.$http.competition.postCompetitionProposalCancel(competitionProposal.id);
          this.onSeeMoreClick(true);
        } catch ({response}) {
          const errorData = response?.data || {};
          const errorMessage = errorData?.message || errorData?.errors || this.$t('140');
          this.showLoader(false);
          this.showToastError(this.$t('139'), errorMessage);
        }
      },
      async onCompetitionProposalRejectAllClick() {
        this.showModal({
          title: this.$t('482'),
          message: this.$t('483'),
          onOkClick: () => this.onCompetitionProposalRejectAll(),
        });
      },
      async onCompetitionProposalRejectAll() {
        try {
          this.showLoader(true);
          await this.$http.competition.postCompetitionProposalRejectAll();
          this.onSeeMoreClick(true);

        } catch (e) {
          this.showLoader(false);
          this.showToastError(this.$t('139'), this.$t('140'));
        }
      },
      showAcceptCompetitionProposalModal(competitionProposal: Record<string, any>) {
        this.competitionProposalSelected = competitionProposal;
        const acceptCompetitionProposalModal: any = this.$refs.acceptCompetitionProposalModal;
        acceptCompetitionProposalModal.$refs.modal.show();
      },
      showAcceptCompetitionDifferentLevelModal(competitionProposal: Record<string, any>) {
        this.competitionProposalSelected = competitionProposal;
        const differentLevelModal: any = this.$refs.differentLevelModal;
        differentLevelModal.$refs.modal.show();
      },
      showRejectCompetitionProposalModal(competitionProposal: Record<string, any>) {
        this.showModal({
          title: this.$t('486'),
          message: this.$t('487'),
          showOnRoot: true,
          onOkClick: () => this.postCompetitionProposalResponse(competitionProposal, 0),
        });
      },
      showCancelCompetitionProposalModal(competitionProposal: Record<string, any>) {
        this.showModal({
          title: this.$t('495'),
          message: this.$t('496'),
          showOnRoot: true,
          onOkClick: () => this.postCompetitionProposalCancel(competitionProposal),
        });
      },
      showPopupNoMoney(competitionProposal: Record<string, any>) {
        const message = this.$createElement(PwaInscriptionNoMoney, {
          props: {
            create: false,
            costInscription: competitionProposal.cost_inscription,
          },
        });
        this.showModal({
          id: 'modal-no-money',
          message,
          showOnRoot: true,
          contentClass: {'no-money': true, 'is-desktop': this.isDesktop, 'hide-footer': true},
        });
      },
      showPopupAddGame(relatedGameId: number) {
        this.showModalById(MODAL_IDS.ADD_GAME, {defaultRelatedGameId: relatedGameId, currentPage: true});
      },
      hasGameConfigured(relatedGameId: number): boolean {
        return Boolean(this.userGames.find(({game_id, validated}) => relatedGameId === game_id && validated === 1));
      },
      acceptCompetitionProposalModalClosed() {
        this.competitionProposalSelected = null;
      },
      showMatchSuccessModal(competitionProposal: Record<string, any>, competitionsFreeInscriptionsId = 0) {
        let competitionFreeInscription = null;
        if (competitionsFreeInscriptionsId) {
          competitionFreeInscription = this.competitionFreeInscriptions.find(({id}) => id === competitionsFreeInscriptionsId);
        }

        let award = null;
        let awardConverted = false;
        if (competitionProposal.userAwardFreeInscription) {
          award = competitionProposal.userAwardFreeInscription;
          awardConverted = false;
        } else {
          award = competitionProposal.userAward;
          awardConverted = true;
        }

        const message = this.$createElement(PwaCreateMatchSuccess, {
          props: {
            gameName: competitionProposal.game_name,
            platformName: competitionProposal.platform_name,
            regionName: competitionProposal.region,
            award,
            awardConverted,
            costInscription: competitionProposal.cost_inscription,
            isCompetitionFreeInscription: Boolean(competitionFreeInscription),
            isCreated: false,
          },
        });

        this.showModal({
          title: this.$t('141'),
          hideCancel: true,
          message,
          showOnRoot: true,
          noCloseOnBackdrop: true,
          noCloseOnEsc: true,
          contentClass: 'create-match-success-background',
          headerClass: 'title-centered',
          onOkClick: () => {
            const params: Record<string, string> = {};
            let routeName = ROUTES.competitions.name;
            if (competitionProposal.competition_id) {
              routeName = ROUTES.competition.name;
              params.competitionId = competitionProposal.competition_id;
            }

            this.routerPush(routeName, params);
            showInterstitial();
          },
        });
      },
      goToUserProfile(username: string) {
        if (username) {
          this.$router.push({name: ROUTES.profile.name, params: {lang: this.routeLang, username}});
        }
      },
      async onSeeMoreClick(updateAll = false) {
        this.showLoader(true);
        const params = {
          limit: updateAll ? this.competitionsProposalsList.length : limitBlock,
          offset: updateAll ? 0 : this.competitionsProposalsList.length,
          sent: this.isCompetitionsProposalsReceived ? 0 : 1,
        };
        const { data } = await this.$http.competition.getCompetitionProposal(params);
        const competitionProposal = data.data || [];
        this.updateCompetitionsProposalsList(competitionProposal, updateAll);
        this.showLoader(false);
      },
      updateCompetitionsProposalsList(competitionProposals: any[], forceReset = false): void {
        if (this.competitionsProposalsList.length > 0 && !forceReset) {
          this.competitionsProposalsList = [...this.competitionsProposalsList, ...competitionProposals]
        } else {
          this.competitionsProposalsList = competitionProposals;
        }

        this.hasMoreCompetitionProposals = competitionProposals.length >= limitBlock;
        this.updateHasPendingCompetitionProposals();
      },
      updateHasPendingCompetitionProposals(): void {
        let hasPendingCompetitionProposals = false;
        if(this.competitionsProposalsList.length > 0 && this.competitionsProposalsList.find((competitionProposal: any) => COMPETITION_PROPOSAL_STATUS_ID.PENDING === competitionProposal.status_id)){
          hasPendingCompetitionProposals = true;
        }

        if (hasPendingCompetitionProposals !== this.hasPendingCompetitionProposals) {
          this.hasPendingCompetitionProposals = hasPendingCompetitionProposals;
        }
      },
      onClickChallengeUserClick(gameAlias: string, relatedGameId: number, username: string) {
        this.createMatch({
          gameAlias: gameAlias,
          gameConfigured: this.hasGameConfigured(relatedGameId),
          competitionProposal: {
            username: username,
          }
        });
      },
    },
    watch: {
      competitionsProposals() {
        this.updateCompetitionsProposalsList(this.competitionsProposals, true);
      }
    }
  });
